import type { RouteObject } from 'react-router';

import { TASKS_PATH } from '../../app/config';

/**
 * `/taches` (P3 §6), as route data for the router — same convention as
 * `shiftsRoutes`/`hoursRoutes`: the feature exports its routes rather than
 * editing `app/router.tsx` directly, because the router owns the
 * authorization nesting.
 *
 * Not in the bottom nav (`AppLayout.tsx`'s four tabs are frozen by its own
 * doc comment — "four labelled tabs"); reached from the home screen's task
 * line and from the punch screen's gated OUT key.
 */
export const tasksRoutes: RouteObject[] = [
  {
    path: TASKS_PATH,
    lazy: async () => ({ Component: (await import('./TasksPage')).TasksPage }),
  },
];

export const routes = tasksRoutes;
